var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"credit"},[_vm._v(" copyright © mr. web designer.all rights reserved! ")])}
var staticRenderFns = []

export { render, staticRenderFns }